import { windowService, documentService } from './window.utils';

function downloadImage(imageSrc, sitecoreContext, title) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', imageSrc, true);
  xhr.setRequestHeader('Access-Control-Allow-Origin', sitecoreContext?.settings?.imageDownloadOrigin);
  xhr.setRequestHeader('Cache-Control', 'no-cache');
  xhr.responseType = 'blob';
  xhr.onload = function () {
    const urlCreator = windowService().URL || windowService().webkitURL;
    const imageUrl = urlCreator.createObjectURL(this.response);
    const anchor = documentService().createElement('a');
    anchor.href = imageUrl;
    anchor.download = title;
    documentService().body.appendChild(anchor);
    anchor.click();
    documentService().body.removeChild(anchor);
  };
  xhr.send();
}

export { downloadImage };
